module.exports = __webpack_public_path__ + "static/img/Edge.42c5e83b.jpeg";